import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { SearchService } from '../services/search_service';
import { Note } from '../types/note';

@Component({
  selector: 'read-more-from-category',
  templateUrl: './read-more-from-notes.component.html',
  styleUrls: ['./read-more-from-notes.component.scss']
})
export class ReadMoreFromNotesComponent implements OnInit {
  @Output() uploaded: EventEmitter<any> = new EventEmitter();
  @Input() title: string | null;
  @Input() category: string;
  @Input() showRandomly: boolean | null;
  @Input() showAfterContainer: {showAfter: number; counter: number};
  @Input() bgColor?: string | null;
  @Input() useTextLinesLimit: boolean | null;

  public notesList: Note[];

  constructor(
    private searchService: SearchService,
  ) {}

  public ngOnInit(): void {
    if (this.showAfterContainer.showAfter && this.showAfterContainer.showAfter === this.showAfterContainer.counter) {
      this.getNotesFromCategory();
    }
  }

  private getNotesFromCategory(): void {
    const query = {
      tag: `type-${this.category}`,
      size: '4'
    };

    this.searchService.getPosts(query).subscribe((notes: any) => {
      this.notesList = notes.posts;
    }, err => {
      console.error('Error while searching for the posts', err);
    });
  }
}
